// clearfix to PDF button controls to match layout

module.exports = function addClearfix() {
    if (document.querySelector('body').classList.contains('single-page')) {
        const singleEmbedDiv = document.querySelector('.single-embed-wrapper');
        if (singleEmbedDiv !== null) {
            singleEmbedDiv.classList.add('clearfix');
        }
    }
};


// WEBPACK FOOTER //
// ./scriptPartials/addClearfix.js